import axios from 'axios';
import store from '../store';

const apiRequest = (url, methodType, data = {}, multipart = false, appendHeader) => {
  let headers = {
    locale: store.state.user.lang,
    timezone: store.state.user.timezone,
  };
  if (multipart) {
    headers['content-type'] = 'multipart/form-data';
  }
  if (appendHeader) {
    for (const key of Object.keys(appendHeader)) {
      headers[key] = appendHeader[key];
    }
  }

  return new Promise((resolve, reject) => {
    axios({
      method: methodType,
      url: url,
      data: data,
      headers: headers,
    })
      .then(response => {
        // Resolve with the full axios response; callers/stores read `.data` (and `.status` etc.).
        resolve(response);
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 401) {
          console.warn('unauthorized, logging out ...' + url);
          postForm('/logout', { toLogin: true, to: location.pathname + location.search + location.hash });
        }
        reject(error.response ? error.response.data : error);
      });
  });
};

const apiImageRequest = (url, contentType) => {
  let headers = {
    ContentType: contentType,
  };

  return new Promise((resolve, reject) => {
    axios({
      responseType: 'arraybuffer',
      method: 'get',
      url: url,
      headers: headers,
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

const apiDownloadRequest = (url, filename = 'file') => {
  var mime = contentType(filename);
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
      headers: { Accept: mime },
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export { apiRequest, apiImageRequest, apiDownloadRequest };
